import { BasicDialogProperties } from "../../../basic/view/dialogs/BasicDialogProperties";

export class Poker2NoMoneyDialogProperties extends BasicDialogProperties {
    public copy: string = "";
    public title: string = "";
    public currencyType: number = 0;

    constructor(title: string, copy: string, currencyType: number) {
        super();

        this.currencyType = currencyType;
        this.title = title;
        this.copy = copy;
    }
}
